<template>
  <div class="tests">
    <div style="position: sticky; top:12px; z-index: 200;">
			<Breadcrumbs :items="items" />
		</div>
    <v-container fluid>
      <v-row no-gutters class="mt-4">
        <v-col v-for="test in tests" cols="12" md="4" class="px-2 treatment-card mb-5" :key="test.id">
          <v-card height="84px" :to="$store.getters.hasRole('manager') ? { name: 'edit-custom-test', params: { tid: test.id } } : null">
            <v-card-title>
              <v-icon color="primary" class="mr-2">assessment</v-icon>
              <span :class="$vuetify.breakpoint.mdAndDown ? 'text-subtitle-1' : 'text-h6'">{{test.name}}</span>
              <v-spacer></v-spacer>
              <v-btn v-if="$store.getters.hasRole('manager')" icon @click.stop.prevent="testToEdit = test; getUsers()" :disabled="loading">
                <v-icon color="primary">mdi-account-group</v-icon>
              </v-btn>
              <!-- <v-btn icon @click="clickEditTest(test)" :disabled="loading">
                <v-icon color="primary">mdi-pencil</v-icon>
              </v-btn> -->
            </v-card-title>
            <v-card-actions></v-card-actions>
          </v-card>
        </v-col>
        <v-col cols="12" md="4" class="px-2 treatment-card mb-5" v-if="$store.getters.hasRole('manager')">
          <v-card :disabled="!$store.getters.hasAnyModule" @click="showNewTest = true">
            <v-card-title>
              <v-row no-gutters align="center" justify="center">
                <v-icon large color="primary" class="my-2">mdi-plus-circle-outline</v-icon>
              </v-row>
            </v-card-title>
          </v-card>
        </v-col>
      </v-row>
      <v-dialog v-model="showNewTest" max-width="70%" scrollable>
        <v-card>
          <v-card-title class="primary--text mb-3 secondary">
            <v-icon color="primary" class="mr-2">assessment</v-icon>
            <translate>New Test</translate>
          </v-card-title>
          <v-card-text>
            <CustomTestSettingsForm ref="newTestForm" :customTest="newTest" :variables="variables" />
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn color="primary" text @click="showNewTest = false">
              <translate>Cancel</translate>
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="addTest" :loading="loading">
              <translate>Create</translate>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="showUsers" max-width="50%">
        <v-card v-if="testToEdit && testToEdit.users_in && testToEdit.users_out">
          <v-card-title class="primary--text mb-3 secondary">
            <v-icon color="primary" class="mr-2">mdi-clipboard-text</v-icon>
            <translate>Manage Access</translate>
            <span class="mx-1">-</span>{{testToEdit.name}}
          </v-card-title>
          <v-card-text>
            <p v-translate class="text-subtitle-1 mb-1">Terapeuts with access</p>
            <p v-if="testToEdit.users_in.length == 0" class="font-weight-thin ml-2 my-2" key="current" v-translate>No professionals selected.</p>
            <v-list v-else flat>
              <v-list-item
                :key="user.id"
                style="border: 1px solid #e0e0e0; border-radius: 5px"
                v-for="user in testToEdit.users_in"
              >
                <v-list-item-icon class="mr-3">
                  <v-icon color="primary">person</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    <strong>{{user.name}}</strong>
                  </v-list-item-title>
                  <v-list-item-subtitle></v-list-item-subtitle>
                </v-list-item-content>
                  <v-list-item-action>
                      <v-btn icon @click="removeUser(user)">
                        <v-icon color="primary">delete</v-icon>
                      </v-btn>
                  </v-list-item-action>
              </v-list-item>
            </v-list>
            <p class="text-subtitle-1 mb-1" v-translate>Other terapeuts</p>
            <p v-if="testToEdit.users_out.length == 0" class="font-weight-thin ml-2 my-2" key="other" v-translate>No more professionals.</p>
            <v-list flat>
              <v-list-item
                :key="user.id"
                style="border: 1px solid #e0e0e0; border-radius: 5px"
                v-for="user in testToEdit.users_out"
              >
                <v-list-item-icon class="mr-3">
                  <v-icon color="primary">person</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    <strong>{{user.name}}</strong>
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn icon @click="addUser(user)">
                    <v-icon color="primary">add</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn color="primary" text @click="showUsers = false; testToEdit = null">
              <translate>Cancel</translate>
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="editUsers" :loading="loading">
              <translate>Save</translate>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import CustomTestSettingsForm from '../../components/appointment/tests/custom/CustomTestSettingsForm.vue';
import Breadcrumbs from "@/components/Breadcrumbs.vue";

export default {
  name: "Tests",
  components: {
    CustomTestSettingsForm,
    Breadcrumbs
  },
	data: () => ({
    tests: [],
    showNewTest: false,
    newTest: {
      name: "",
      fields: []
    },
    showEdit: false,
    showDeleteAlert: false,
    showUsers: false,
    testToEdit: null,
    loading: false,
    variables: []
  }),
  computed: {
    items() {
			return [
				{text: this.$gettext("Dashboard"), disabled: false, link: true, to: { name: "home" }},
        {text: this.$gettext("Tests"), disabled: false, link: true, to: { name: "tests" }}
			]
    },
    required() {
			return value => !!value || this.$gettext("Required.");
    },
    fieldOptions() {
			return [
				{ value: "text", text: this.$gettext("Text") },
        { value: "bool", text: this.$gettext("Boolean") },
        { value: "degree", text: this.$gettext("Degree") }
			];
		}
  },
  methods: {
    addTest() {
      if(this.$refs.newTestForm.validate()) {
        this.loading = true;
        axios
          .post("/custom-tests/new", this.newTest)
          .then(response => {
            console.log(response.data);
            if (response.data.result == "ok") {
              this.tests.push(response.data.test);
              this.showNewTest = false;
            }
            this.loading = false;
          })
          .catch(error => {
            console.log(error);
            this.loading = false;
          });
      }
    },
    clickEditTest(test) {
      for(let i = 0; i < test.fields.length; i++) {
        this.$set(test.fields[i], 'edit', false);
      }
      this.testToEdit = test;
      this.showNewField = false;
      this.showEdit = true;
    },
    editTest() {
      if(this.$refs.testForm.validate()) {
        this.loading = true;
        axios
          .post("/custom-tests/" + this.testToEdit.id, this.testToEdit)
          .then(response => {
            console.log(response.data);
            if (response.data.result == "edited") {
              this.showEdit = false;
              for(let i=0; i<this.tests.length; i++) {
                if(this.tests[i].id == response.data.test.id) this.tests[i] = response.data.test;
              }
            }
            this.loading = false;
          })
          .catch(error => {
            console.log(error);
            this.loading = false;
          });
      }
    },
    removeTest(test) {
      this.loading = true;
      axios
				.post("/custom-tests/" + test.id + "/delete")
				.then(response => {
					console.log(response.data);
					if (response.data.result == "deleted") {
            this.tests.splice(this.tests.indexOf(test), 1);
            this.showDeleteAlert = false;
            this.showEdit = false;
          }
          this.loading = false;
				})
				.catch(error => {
          console.log(error);
          this.loading = false;
        });
    },
    getUsers() {
      this.loading = true;
      axios
				.get("/custom-tests/" + this.testToEdit.id + "/users")
				.then(response => {
          console.log(response.data);
          this.$set(this.testToEdit, 'users_in', response.data.users_in);
          this.$set(this.testToEdit, 'users_out', response.data.users_out);
          this.loading = false;
          this.showUsers = true;
				})
				.catch(error => {
          console.log(error);
          this.loading = false;
        });
    },
    editUsers() {
      this.loading = true;
      axios
				.post("/custom-tests/" + this.testToEdit.id + "/users", this.testToEdit.users_in)
				.then(response => {
          console.log(response.data);
          this.loading = false;
          this.showUsers = false;
				})
				.catch(error => {
          console.log(error);
          this.loading = false;
        });
    },
    removeUser(user) {
      this.testToEdit.users_in.splice(this.testToEdit.users_in.indexOf(user), 1);
      this.testToEdit.users_out.push(user);
    },
    addUser(user) {
      this.testToEdit.users_out.splice(this.testToEdit.users_out.indexOf(user), 1);
      this.testToEdit.users_in.push(user);
    }
  },
  created() {
    axios
			.get("/custom-tests")
			.then(response => {
				console.log(response.data);
				if (response.status === 200) {
          this.tests = response.data.custom_tests;
					this.variables = response.data.variables;
				}
			})
			.catch(error => console.log(error));
  }
};
</script>